module.exports = __webpack_public_path__ + "static/media/9DESA36.2628b8e9.jpg";